import type { ModelFacade } from "@/utils/useEngineModel/ModelFacade"
import { useDataHealthStore } from "./dataHealth"
import { useFileImportStore } from "./fileImport"
import { useIntegrationStore } from "./integration"
import { useListImportStore } from "./listImport"
import { usePageStore } from "./page"
import { usePagesStore } from "./pages"
import { useProjectStore } from "./project"

export * from "./auth"
export * from "./dataHealth"
export * from "./fileImport"
export * from "./integration"
export * from "./listImport"
export * from "./page"
export * from "./pages"
export * from "./playground"
export * from "./project"
export * from "./settings"
export * from "./setup"
export * from "./tableInspect"

// Helper function to set the ModelFacade to allow access to the model from
// within the stores.
export async function initialiseStores(
  model: ModelFacade,
  options?: {
    includeIntegrations?: boolean
    includeFileImport?: boolean
    includeListImport?: boolean
    includeDataHealth?: boolean
  }
) {
  const includeIntegrations = options?.includeIntegrations ?? true
  const includeFileImport = options?.includeFileImport ?? true
  const includeListImport = options?.includeListImport ?? true
  const includeDataHealth = options?.includeDataHealth ?? true

  await useProjectStore().initialise(model)
  usePageStore().initialise(model)
  usePagesStore().initialise(model)

  if (includeFileImport) {
    useFileImportStore().initialise(model)
  }

  if (includeListImport) {
    useListImportStore().initialise(model)
  }

  if (includeDataHealth) {
    useDataHealthStore().initialise(model)
  }

  if (includeIntegrations) {
    await useIntegrationStore().initialise(model)
  }
}
